// Shared between Beacon4KpiLineChart (draws the vertical markers) and
// Beacon4PerformanceNetworkOverviewLegendPanel (lists them with a matching
// swatch) — both need the EXACT same activity → colour assignment, so it
// lives here once rather than being computed independently in two places
// (which would drift the moment either file's rotation logic changed).
export const ACTIVITY_COLORS = ['#8e24aa', '#00897b', '#c62828', '#3949ab', '#f9a825', '#00acc1']

// Assigns each activity a stable colour based on its position in the given
// list — same rotation every time the SAME list (same order) is passed in,
// which is what both consumers do (they both derive from
// selectBeacon4SelectedActivities).
export function assignActivityColors(activities) {
  return (activities ?? []).map((a, i) => ({ ...a, color: ACTIVITY_COLORS[i % ACTIVITY_COLORS.length] }))
}
